export const REGISTER_OPEN = '@REGISTER_OPEN';
export const REGISTER_CLOSE = '@REGISTER_CLOSE';
export const TOUR_CLOSE = '@TOUR_CLOSE';
export const TOUR_OPEN = '@TOUR_OPEN';
export const TOUR_POPUP_OPEN = '@TOUR_POPUP_OPEN';
export const TOUR_POPUP_CLOSE = '@TOUR_POPUP_CLOSE';
